<template>
  <v-dialog
    persistent
    max-width="500"
    v-model="isModalOpen"
  >
    <v-card class="loading_modal">
      <v-card-text class="d-flex flex-wrap justify-center text-center">
        <v-progress-circular
          class="circular"
          :size="80"
          :width="7"
          indeterminate
        ></v-progress-circular>
        <p class="black--text note">{{ $t('loading-modal.note') }}</p>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "LoadingModal",
  data() {
    return {
      isModalOpen: false,
    }
  },
  methods: {
    closeModal() {
      this.isModalOpen = false
    }
  }
}
</script>